const getBaseLanguageCodes = (rootState) => rootState.config.common.language_codes.base;

export default getBaseLanguageCodes;
